import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { AuthDescription } from '@/components/features/auth/auth-description';
import { ChangePasswordForm } from '@/components/features/auth/forms/change-password-form';
import { ResetPasswordForm } from '@/components/features/auth/forms/reset-password-form';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PublicPage } from '@/components/ui/layout/public-page';

const resetPasswordSearchSchema = z.object({
  token: z.number().optional(),
});

export const Route = createFileRoute('/_public/reset-password')({
  component: ResetPassword,
  validateSearch: (search) => resetPasswordSearchSchema.parse(search),
});

export function ResetPassword() {
  const search = Route.useSearch();
  const { t } = useTranslation();

  return (
    <PublicPage.Layout>
      <PublicPage.Header />
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl text-center">
            {t('auth.resetPassword.title')}
          </CardTitle>
          <AuthDescription type="resetPassword" />
        </CardHeader>

        <CardContent>
          {search?.token ? (
            <ChangePasswordForm token={search.token} />
          ) : (
            <ResetPasswordForm />
          )}
        </CardContent>

        <CardFooter className="flex justify-center">
          <p className="text-sm text-muted-foreground">
            {t('auth.layout.footer.rememberPassword')}{' '}
            <Link to="/login" className="text-primary hover:underline">
              {t('auth.layout.footer.login')}
            </Link>
          </p>
        </CardFooter>
      </Card>
    </PublicPage.Layout>
  );
}
